// ======================================================================
// File Name       : UserHistoryCourseDetailContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import moment from 'moment';
import React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import * as CourseHistoryActions from '../../../actions/UserHistoryCourseAction';
import * as StudentHistoryActions from '../../../actions/UserHistoryStudentAction';
import Header from '../../../components/Header';
import CourseDetail from '../../../components/userHistory/course/CourseHistoryDetail';
import * as actionType from '../../../constants/actionTypes/page';
import { DEFAULT_YEAR_MONTH_SEARCH, RETURN_MAX_NUM } from '../../../constants/index';
import * as Path from '../../../constants/PathConstants';
import { hideLoading, showLoading } from '../../../utils/PageUtils';
import CustomLink from '../../../components/button/CustomLink';

class CourseHistoryDetailContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      startPosition: 0,
      courseStatusSortType: 0,
      ascendingDescendingSort: 0,
      returnMaxNum: RETURN_MAX_NUM,
      targetMonth: moment(new Date()), // #7386
    };
    this.getStartEndData = this.getStartEndData.bind(this);
    this.backPage = this.backPage.bind(this);
    this.getUserHistoryCourseDetail = this.getUserHistoryCourseDetail.bind(this);
    this.handleSortState = this.handleSortState.bind(this);
    this.goToDetail = this.goToDetail.bind(this);
    this.onRegisterSendMail = this.onRegisterSendMail.bind(this);
    // #7386 START
    this.getPreviousMonthBarChart = this.getPreviousMonthBarChart.bind(this);
    this.getNextMonthBarChart = this.getNextMonthBarChart.bind(this);
    // #7386 END
    this.handleMouseEnter = this.handleMouseEnter.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
  }

  getUserHistoryCourseDetail() {
    const { match } = this.props;
    const id = match.params.id;
    if (id === undefined) this.backPage();
    this.props.dispatch(CourseHistoryActions.getUserHistoryCourseDetail(id, this.state));
  }

  componentWillMount() {
    const { searchConditionHistoy } = this.props;
    this.setState({
      ...this.state,
      ...searchConditionHistoy,
    }, () => {
      this.getUserHistoryCourseDetail();
    });
  }

  componentWillUnmount() {
    this.props.dispatch(CourseHistoryActions.setUserHistoryCourseInitData(true));
    const filterData = this.state;
    const { courseDetail } = this.props;
    this.props.dispatch(StudentHistoryActions.saveHistoryCourseDetail(courseDetail));
    this.props.dispatch({
      type: actionType.SAVE_SEARCH_CONDITION_HISTORY,
      parentPathHistory: Path.USER_HISTORY_COURSE_DETAIL,
      searchConditionHistoy: filterData,
    });
  }

  getStartEndData(startPosition) {
    this.setState({ startPosition,
    }, () => this.props.dispatch(CourseHistoryActions.getPagingHistoryCourseDetail(this.props.courseDetail, this.state, null)));
  }

  handleSortState(row) {
    let startPosition = 0;
    if (this.state.startPosition && this.state.startPosition > 0) {
      startPosition = this.state.startPosition;
    }
    this.setState({
      startPosition,
      courseStatusSortType: row.sortBy,
      ascendingDescendingSort: row.sortState,
    }, () => this.props.dispatch(CourseHistoryActions.getPagingHistoryCourseDetail(this.props.courseDetail, this.state, null)));
  }

  backPage() {
    this.props.dispatch(CourseHistoryActions.setUserHistoryCourseInitData(false));
  }

  onRegisterSendMail() {
    const { courseDetail, dispatch } = this.props;
    dispatch(showLoading());
    dispatch(CourseHistoryActions.getAllUserToSendMail(courseDetail)).then(() => {
      dispatch(hideLoading());
      this.props.history.push(Path.EMAIL_REGISTER);
    });
  }

  goToDetail(userSecernId) {
    const filterData = this.state;
    if (!userSecernId) return;
    const { courseDetail } = this.props;
    this.props.dispatch(StudentHistoryActions.saveHistoryCourseDetail(courseDetail));
    const path = Path.USER_HISTORY_COURSE_STUDENT_DETAIL.replace(':id', userSecernId);
    this.props.history.push(path);
    if (userSecernId) {
      this.props.dispatch({
        type: actionType.SAVE_SEARCH_CONDITION_HISTORY,
        parentPathHistory: Path.USER_HISTORY_COURSE_DETAIL,
        searchConditionHistoy: filterData,
      });
    }
  }

  // #7386 START
  getPreviousMonthBarChart() {
    let { targetMonth } = this.state;
    const { match, dispatch } = this.props;
    targetMonth = targetMonth.subtract(1, 'month').format(DEFAULT_YEAR_MONTH_SEARCH);
    const params = {
      courseSecernId: match.params.id,
      targetMonth,
    };
    dispatch(CourseHistoryActions.getBarChartData(params));
  }

  getNextMonthBarChart() {
    let { targetMonth } = this.state;
    const { match, dispatch} = this.props;
    targetMonth = targetMonth.add(1, 'month').format(DEFAULT_YEAR_MONTH_SEARCH);
    const params = {
      courseSecernId: match.params.id,
      targetMonth,
    };
    dispatch(CourseHistoryActions.getBarChartData(params));
  }
  // #7386 END
  handleMouseEnter(index) {
    this.setState({
      hoverIndex: index,
    });
  }

  handleMouseLeave() {
    this.setState({
      hoverIndex: undefined,
    });
  }

  render() {
    const { courseDetail, isExist , authedUser} = this.props;
    if (!isExist) {
      return <Redirect to={Path.USER_HISTORY_COURSE_LIST} />;
    }
    const { hoverIndex } = this.state;
    const { managementFunctionAuthorityInfo } = authedUser; // STEP13.0.0 TAS-22571
    return (
      <div>
        <CustomLink
          className="margin-right-7 url-list"
          to={Path.USER_HISTORY_COURSE_LIST}
          text="学習履歴一覧に戻る"
          icon="bi bi-chevron-left"
        />
        <Header name="コース別履歴情報の詳細" />

        <CourseDetail
          getStartEndData={this.getStartEndData}
          startPosition={this.state.startPosition}
          handleSortState={this.handleSortState}
          onGoToListScreen={this.backPage}
          goToDetail={this.goToDetail}
          dataSort={this.state}
          onRegisterSendMail={this.onRegisterSendMail}
          getPreviousMonthBarChart={this.getPreviousMonthBarChart}
          getNextMonthBarChart={this.getNextMonthBarChart}
          hoverIndex={hoverIndex}
          handleMouseEnter={this.handleMouseEnter}
          handleMouseLeave={this.handleMouseLeave}
          managementFunctionAuthorityInfo={managementFunctionAuthorityInfo} // STEP13.0.0 TAS-22571
        />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { courseDetail } = state.userHistoryCourse;
  const { isExist } = state.userHistoryCourse;
  const { parentPathHistory, searchConditionHistoy } = state.page;
  const { authedUser } = state.authed; // STEP13.0.0 TAS-22571
  return {
    ...{ courseDetail },
    ...{ authedUser },
    ...{ isExist },
    searchConditionHistoy,
    parentPathHistory,
  };
};

export default connect(mapStateToProps)(CourseHistoryDetailContainer);
